<template>
<div class="col-12">
    <a href="javascript:window.print()" class="print-button">Print</a>
    <br />
    <div class="form-group">
    <h2>Purchase Invoice</h2>
    </div>
    <br />
    <app-common-report-template :elements="elements" :collections="pi"></app-common-report-template>
</div>
</template>

<script>
import api from '../../../services/api'
import AppCommonReportTemplate from '../../../components/AppCommonReportTemplate.vue'

export default {
    data() {
        return {
            elements: {
                header: [],
                content: [
                    {
                        title: 'No. Transaksi',
                        column: 'transactionNo',
                        type: 'text'
                    },
                    {
                        title: 'Tanggal',
                        column: 'date',
                        type: 'date'
                    },
                    // // {
                    // //     title: 'Vendor Code',
                    // //     column: 'vendorCode',
                    // //     type: 'text'
                    // // },
                    // // {
                    // //     title: 'Vendor Name',
                    // //     column: 'vendorName',
                    // //     type: 'text'
                    // // },
                    // {
                    //     title: 'Product Code',
                    //     column: 'productCode',
                    //     type: 'text'
                    // },
                    {
                        title: 'Nama Produk',
                        column: 'productName',
                        type: 'text'
                    },
                    {
                        title: 'Qty',
                        column: 'qty',
                        type: 'text'
                    },
                    {
                        title: 'Harga',
                        column: 'price',
                        type: 'text'
                    },
                    {
                        title: 'PPN',
                        column: 'ppn',
                        type: 'text'
                    },
                    {
                        title: 'PPH',
                        column: 'pph',
                        type: 'text'
                    },
                    {
                        title: 'Subtotal',
                        column: 'subtotal',
                        type: 'text'
                    },
                ]
            },
            pi: { }
        }
    },
    components: {
        AppCommonReportTemplate
    },
    async created() {
        if(this.$route.query.id !== undefined) {
            const piApi = api('print/purchase-invoice')
            const query = {
                params: {
                    ...this.$route.query
            }
        }
            this.pi = await piApi.getWithQuery(query)
        }
    }
}
</script>